import { SimulatorForm } from "components/education/simulator-form";
import LandingSection from "components/common/landing-section";

import { useAtomValue } from "lib/global-context";
import useSendHeightToParent from "hooks/useSendHeightToParent";
import { currentStepAtom } from "lib/atoms";
import schema from "data/schema/education-planning.json";
import PageContainer from "components/common/page-container";

export default function Home() {
  useSendHeightToParent();

  const setCurrentStep = useAtomValue(currentStepAtom);

  const { title, description, ctaButtonText, imageSrc, note, subheading } =
    schema.questionnaire.displayConfiguration;
  const questions = schema.questionnaire.questions;

  return (
    <PageContainer page="education">
      {setCurrentStep === 0 ? (
        <LandingSection
          page="education"
          imageSrc={imageSrc}
          headline={title}
          subheading={subheading}
          body={description}
          buttonText={ctaButtonText}
          note={note}
        />
      ) : (
        <SimulatorForm questions={questions} />
      )}
    </PageContainer>
  );
}
